import * as React from "react";

import { LogoProps } from "./types";

export const LogoOnly = React.forwardRef((props: LogoProps, ref: any) => {
    const height = props.height || "32";
    const width = props.width || "32";
    return (
        <svg
            width={width}
            height={height}
            className={props.className}
            viewBox="0 0 80 80"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.943 52.362c-3.267-10.13-2.393-20.926 2.46-30.399C9.256 12.49 17.508 5.473 27.638 2.206 48.55-4.54 71.05 6.99 77.793 27.901l-17.9 5.773c-3.56-11.04-15.441-17.128-26.483-13.567a20.902 20.902 0 0 0-12.268 10.431 20.908 20.908 0 0 0-1.298 16.051l-17.9 5.773"
                fill="#A6D3F4"
            />
            <path
                d="M39.482 79.999c-6.116-.053-12.18-1.532-17.782-4.401-9.474-4.853-16.49-13.105-19.757-23.236l17.9-5.773a20.908 20.908 0 0 0 10.432 12.269 20.908 20.908 0 0 0 16.052 1.298 20.902 20.902 0 0 0 12.267-10.432 20.902 20.902 0 0 0 1.3-16.05l17.9-5.773c3.267 10.13 2.394 20.926-2.46 30.399C70.481 67.774 62.23 74.79 52.1 78.058a39.953 39.953 0 0 1-12.617 1.94"
                fill="#E35AFC"
            />
        </svg>
    );
});
